import React from 'react';

/** Strategy/Planning - Geometric X's and O's */
export const StrategyIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <circle cx="55" cy="55" r="12" className="illustration-stroke"
            strokeWidth="3" fill="none" opacity="0.6"/>
    <path d="M20 20 L35 35 M35 20 L20 35" className="illustration-stroke"
          strokeWidth="3" strokeLinecap="round" opacity="0.5"/>
    <path d="M55 15 L55 30" className="illustration-stroke"
          strokeWidth="3" strokeLinecap="round" opacity="0.4"/>
    <path d="M50 22 L60 22" className="illustration-stroke"
          strokeWidth="2" strokeLinecap="round" opacity="0.3"/>
    <path d="M15 55 L30 55" className="illustration-stroke"
          strokeWidth="2" strokeLinecap="round" opacity="0.3"/>
  </svg>
);

/** Campaign/Review - Megaphone */
export const CampaignIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <path d="M15 50 L15 30 L50 18 L50 62 L15 50 Z" className="illustration-stroke"
          strokeWidth="3" fill="none" opacity="0.5"/>
    <rect x="50" y="32" width="18" height="16" rx="2" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.4"/>
    <line x1="15" y1="50" x2="8" y2="55" className="illustration-stroke"
          strokeWidth="2" opacity="0.3"/>
    <line x1="15" y1="30" x2="8" y2="25" className="illustration-stroke"
          strokeWidth="2" opacity="0.3"/>
  </svg>
);

/** Standup/Team - Connected people circles */
export const TeamIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <circle cx="25" cy="28" r="9" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.5"/>
    <circle cx="55" cy="28" r="9" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.5"/>
    <circle cx="40" cy="55" r="9" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.5"/>
    <path d="M32 34 L48 34" className="illustration-stroke"
          strokeWidth="2" strokeDasharray="4 3" opacity="0.3"/>
    <path d="M29 36 L35 48" className="illustration-stroke"
          strokeWidth="2" strokeDasharray="4 3" opacity="0.3"/>
    <path d="M51 36 L45 48" className="illustration-stroke"
          strokeWidth="2" strokeDasharray="4 3" opacity="0.3"/>
  </svg>
);

/** Design/Creative - Geometric shapes */
export const DesignIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <rect x="15" y="18" width="22" height="22" rx="3" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.5"/>
    <circle cx="55" cy="55" r="14" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.5"/>
    <polygon points="55,18 68,42 42,42" className="illustration-stroke"
             strokeWidth="2" fill="none" opacity="0.4"/>
  </svg>
);

/** 1:1 / Interview - Two overlapping circles */
export const OneOnOneIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <circle cx="28" cy="32" r="12" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.5"/>
    <circle cx="52" cy="32" r="12" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.5"/>
    <path d="M22 50 Q40 68 58 50" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.3"/>
  </svg>
);

/** All-Hands / Company - Building */
export const AllHandsIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <rect x="22" y="28" width="36" height="40" rx="2" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.5"/>
    <rect x="35" y="48" width="10" height="20" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.4"/>
    <rect x="27" y="34" width="8" height="8" className="illustration-stroke"
          strokeWidth="1.5" fill="none" opacity="0.4"/>
    <rect x="45" y="34" width="8" height="8" className="illustration-stroke"
          strokeWidth="1.5" fill="none" opacity="0.4"/>
    <rect x="27" y="46" width="6" height="6" className="illustration-stroke"
          strokeWidth="1.5" fill="none" opacity="0.3"/>
    <rect x="47" y="46" width="6" height="6" className="illustration-stroke"
          strokeWidth="1.5" fill="none" opacity="0.3"/>
    <path d="M40 18 L40 28" className="illustration-stroke" strokeWidth="2" opacity="0.3"/>
    <circle cx="40" cy="14" r="4" className="illustration-stroke"
            strokeWidth="1.5" fill="none" opacity="0.3"/>
  </svg>
);

/** Training/Learning - Book + magnifying glass */
export const TrainingIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <path d="M20 55 L20 30 L55 30 L55 55 L20 55" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.5"/>
    <path d="M25 30 L25 25 L50 25 L50 30" className="illustration-stroke"
          strokeWidth="2" fill="none" opacity="0.4"/>
    <circle cx="60" cy="25" r="8" className="illustration-stroke"
            strokeWidth="2" fill="none" opacity="0.4"/>
    <path d="M57 25 L63 25 M60 22 L60 28" className="illustration-stroke"
          strokeWidth="1.5" opacity="0.5"/>
  </svg>
);

/** Abstract/Generic - Soft blobs */
export const AbstractIllustration = ({ className }) => (
  <svg className={className} viewBox="0 0 80 80" fill="none">
    <ellipse cx="45" cy="30" rx="25" ry="20" className="illustration-fill" opacity="0.25"/>
    <ellipse cx="50" cy="50" rx="18" ry="16" className="illustration-fill" opacity="0.18"/>
    <circle cx="30" cy="60" r="12" className="illustration-fill" opacity="0.12"/>
  </svg>
);

/** Map illustration name to component */
export const ILLUSTRATIONS = {
  strategy: StrategyIllustration,
  campaign: CampaignIllustration,
  team: TeamIllustration,
  design: DesignIllustration,
  oneOnOne: OneOnOneIllustration,
  allHands: AllHandsIllustration,
  training: TrainingIllustration,
  abstract: AbstractIllustration,
};
